import React, {useState} from 'react';
import {isEmail, setElementAttribute} from "../utils/common-utils.ts";
import ReactDOM from "react-dom/client";
import {renderTextField, renderTextArea, renderEmailField, renderDropdown} from "./fields/FormFields.tsx";

export const renderFormContactFr = (div: string) => {
    const root = document.getElementById(div)
    if (root) {
        ReactDOM.createRoot(root).render(<React.StrictMode><FormContactFr/></React.StrictMode>)
    }
}

const FormContactFr = () => {

    const [name, setName] = useState('');
    const [city, setCity] = useState('');
    const [emailAddress, setEmailAddress] = useState('');
    const [phone, setPhone] = useState('');
    const [commentOn, setCommentOn] = useState('select');
    const [commentDetails, setCommentDetails] = useState('');
    const [submitted, setSubmitted] = useState(false);

    const renderName = () => {
        const inputData = {
            name: 'name',
            id: 'nom',
            label: 'Nom',
            type: 'text',
            autoComplete: 'name',
            inputMode: 'text',
            value: '',
            required: true,
            description: 'field_description_name',
            message: 'Votre nom est obligatoire. Veuillez entrer votre nom.',
            errorMessageID: 'name_error_message',
            visible: false
        }
        return renderTextField(inputData, name, setName, submitted);
    }

    const renderCity = () => {
        const inputData = {
            name: 'city',
            id: 'location',
            label: 'Ville',
            type: 'text',
            autoComplete: 'address-level2',
            inputMode: 'text',
            value: '',
            required: true,
            description: 'field_description_city',
            message: 'Votre emplacement est obligatoire. Veuillez entrer votre ville.',
            errorMessageID: 'city_error_message',
            visible: false
        }
        return renderTextField(inputData, city, setCity, submitted);
    }

    const renderEmailDetails = () => {
        const inputData = {
            name: 'email',
            id: 'emailAddress',
            label: 'Adresse courriel',
            type: 'email',
            required: true,
            description: 'field_description_email',
            message: 'Votre adresse courriel est obligatoire. Veuillez fournir une adresse courriel valide.',
            errorMessageID: 'email_error_message',
            visible: true,
            success: 'Merci pour votre adresse courriel.'
        }
        return renderEmailField(inputData, emailAddress, setEmailAddress, submitted);
    }

    const renderPhoneDetails = () => {
        const inputData = {
            name: 'phone',
            id: 'phoneNumber',
            label: 'Téléphone',
            type: 'tel',
            inputMode: 'tel',
            required: false,
            autoComplete: 'tel-national',
            description: 'field_description_phone',
            message: 'Votre numéro de téléphone est facultatif.',
            errorMessageID: '',
            visible: false
        }
        return renderTextField(inputData, phone, setPhone, submitted);
    }

    const renderCommentChoices = () => {
        const inputData = {
            name: 'commentChoice',
            id: 'commentChoice',
            label: 'Sélectionner',
            option: [
                {label: '- Choisir -', value: 'select'},
                {label: 'Général', value: 'Général'},
                {label: 'Site web', value: 'Site web'},
                {label: 'Vidéos archivées', value: 'Vidéos archivées'},
                {label: 'Émissions de CPAC', value: 'Émissions de CPAC'},
                {label: 'Carrières', value: 'Carrières'},
                {label: 'CPAC dans votre région', value: 'CPAC dans votre région'},
                {label: 'Commander une vidéo', value: 'Commander une vidéo'},
                {label: 'Médias sociales', value: 'Médias sociales'},
            ],
            required: true,
            description: 'field_description_select',
            message: 'Veuillez sélectionner un sujet de commentaire.',
            errorMessageID: 'comment_choice_error_message',
            visible: false
        }
        return renderDropdown(inputData, commentOn, setCommentOn, submitted);
    }

    const renderComments = () => {
        const inputData = {
            name: 'comments',
            id: 'comments',
            label: 'Commentaires',
            inputMode: 'text',
            description: 'field_description_comments',
            message: 'Veuillez nous faire part de vos commentaires ou de vos questions.',
            errorMessageID: 'comments_error_message',
            required: true,
            visible: false
        }
        return renderTextArea(inputData, commentDetails, setCommentDetails, submitted);
    }

    const handleSubmit = (e: any) => {
        e.preventDefault();
        const hasErrors = !name || !city || !emailAddress || !isEmail(emailAddress) || !commentDetails || !commentOn || commentOn === 'select' || commentOn === '' ? true : false;
        setSubmitted(true);
        const mailSubject = "?subject=Submission : Contactez-nous";
        const mailBody = `&body=Nom : ${name} %0D%0AVille : ${city}%0D%0AAdresse courriel : ${emailAddress}%0D%0ATéléphone : ${phone}%0D%0ACommenter sur : ${commentOn}%0D%0ACommentaires : ${commentDetails}` ;
        const sendMail = "mailto:comments@cpac.ca";
        const errorMessages = document.querySelector("#error_summary") as HTMLElement | null;
        if (hasErrors) {    
            setElementAttribute("error_summary", "aria-labelledby", "error_summary_heading");
            document.getElementById("error_summary")?.focus();
        } else {
            window.open(sendMail + mailSubject + mailBody);
            e.target.reset();
            setName('');
            setCity('');
            setEmailAddress('');
            setPhone('');
            setCommentOn('select');
            setCommentDetails('');
            setSubmitted(false);
            errorMessages?.removeAttribute("aria-labelledby");
        }
    }

    return (
        <>
            {
                <div id="form_wrapper" className="form_wrapper" itemScope itemType="https://schema.org/ContactPage">
                    <div id='error_summary' aria-live="assertive" tabIndex={-1}>
                        {submitted && (!name || !city || !emailAddress || !isEmail(emailAddress) || !commentDetails || !commentOn || commentOn === 'select' || commentOn === '') ? <h2 id='error_summary_heading' role='alert' className='error_message invalid'>Il y a des erreurs dans le formulaire.<br/><span>Veuillez corriger les erreurs et soumettre à nouveau.</span></h2> : null}
                        <ul className="reg-list">
                        {submitted && !name ? <li id='name_error_message' className='error_message invalid'><a href="#nom"><img alt="" className="error-icon" src="/static-assets/images/common/error.svg" /> Veuillez entrer votre nom.</a></li> : null}
                        {submitted && !city ? <li id='city_error_message' className='error_message invalid'><a href="#location"><img alt="" className="error-icon" src="/static-assets/images/common/error.svg" /> Veuillez entrer votre ville.</a></li> : null}
                        {submitted && !isEmail(emailAddress) ? <li id='email_error_message' className='error_message invalid'><a href="#emailAddress"><img alt="" className="error-icon" src="/static-assets/images/common/error.svg" /> Veuillez entrer une adresse courriel valide.</a></li> : null}
                        {submitted && (!commentOn || commentOn === 'select' || commentOn === '') ? <li id='comment_choice_error_message' className='error_message invalid'><a href="#commentChoice"><img alt="" className="error-icon" src="/static-assets/images/common/error.svg" /> Veuillez sélectionner un sujet de commentaire.</a></li> : null}
                        {submitted && !commentDetails ? <li id='comments_error_message' className='error_message invalid'><a href="#comments"><img alt="" className="error-icon" src="/static-assets/images/common/error.svg" /> Veuillez entrer vos commentaires.</a></li> : null}
                        </ul>
                    </div>
                    <form aria-label="formulaire de contact" onSubmit={(e) => handleSubmit(e)} itemScope itemType="https://schema.org/WebPageElement" noValidate>
                        <div className="form_body" itemProp='mainEntityOfPage'>
                            {renderName()}
                            {renderCity()}
                            {renderEmailDetails()}
                            {renderPhoneDetails()}
                            {renderCommentChoices()}
                            {renderComments()}
                        </div>
                        <div className='form_footer left_label'>
                            <button type="submit" name='submit' className="btn--primary">Envoyer par courrier électronique</button>
                        </div>
                    </form>
                </div>
            }
        </>
    )
}

export default FormContactFr;